var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"document-details"},[_c('e-tabs',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }